"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MobileLanguageSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _Network = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/05-Internet-Networks-Servers/01-Worldwide-Web/Network"));
var _spacer = _interopRequireDefault(require("@berlitz/spacer"));
var _NavigationColumn = _interopRequireDefault(require("./NavigationColumn"));
var _MobileLanguageSelector = require("./MobileLanguageSelector.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Title = function Title(_ref) {
  var activeLanguage = _ref.activeLanguage;
  return /*#__PURE__*/_react.default.createElement(_MobileLanguageSelector.TitleWrapper, null, /*#__PURE__*/_react.default.createElement(_spacer.default, {
    size: "xs",
    noTop: true,
    noLeft: true,
    noBottom: true
  }, /*#__PURE__*/_react.default.createElement(_Network.default, {
    color: "ui03"
  })), activeLanguage);
};
var MobileLanguageSelector = function MobileLanguageSelector(_ref2) {
  var languageLinks = _ref2.languageLinks,
    activeLanguage = _ref2.activeLanguage;
  return /*#__PURE__*/_react.default.createElement(_MobileLanguageSelector.MobileLanguageSelectorWrapper, null, /*#__PURE__*/_react.default.createElement(_NavigationColumn.default, {
    title: /*#__PURE__*/_react.default.createElement(Title, {
      activeLanguage: activeLanguage
    }),
    links: languageLinks
  }));
};
exports.MobileLanguageSelector = MobileLanguageSelector;
var _default = MobileLanguageSelector;
exports.default = _default;